// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__1BFV2","table":"style_table__3k6vP","reason":"style_reason__3q_79","input":"style_input__zB_79","footer":"style_footer__1xDjX"};